import BaseService from "./base.service";

export default class BannerService extends BaseService {
    constructor(ctx) {
        super(ctx)
    }

    getBannerByKey = (query) => {
        return this.get('/banner', query)
    }
}
